import styles from "./Citites.module.scss";
import UfaImage from "./images/ufa.svg";
import KazanImage from "./images/kazan.svg";
import EkbImage from "./images/ekb.svg";
import SpbImage from "./images/spb.svg";

import MapIcon from "./images/map.svg";
import CallIcon from "./images/phoneIcon.svg";
import MailIcon from "./images/mail.svg";

const Cities = () => {
  return (
    <div className={styles.cities}>
      {/* ufa  */}
      <div
        className={styles.ufa}
        style={{ "--bg-image": `url(${UfaImage})` } as any}
      >
        <div className={styles.content}>
          {/* top  */}
          <div className={styles.top}>
            <p className={styles.cityName}>Уфа</p>

            <div className={styles.address}>
              <img src={MapIcon} alt="Адрес" className={styles.icon} />
              <p className={styles.text}>Ул. Менделеева 219</p>
            </div>

            <div className={styles.address}>
              <img src={MapIcon} alt="Адрес" className={styles.icon} />
              <p className={styles.text}>Ул. Революционная 173</p>
            </div>
          </div>

          {/* bot */}
          <div className={styles.bot}>
            <div className={styles.contact}>
              <img
                src={CallIcon}
                alt="Номер телефона"
                className={styles.icon}
              />
              <a className={styles.text} href="tel:73472588588">
                +7 (347) 2-588-588
              </a>
            </div>

            <div className={styles.contact}>
              <img src={MailIcon} alt="Почта" className={styles.icon} />
              <a className={styles.text} href="mailto:ufa@saby.pro">
                ufa@saby.pro
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* other cities  */}
      <div className={styles.other}>
        {/* Kazan  */}
        <div
          className={styles.city}
          style={{ "--bg-image": `url(${KazanImage})` } as any}
        >
          <div className={styles.content}>
            <div className={styles.top}>
              <p className={styles.cityName}>Казань</p>

              <div className={styles.address}>
                <img src={MapIcon} alt="Адрес" className={styles.icon} />
                <p className={styles.text}>Ул. Баумана, д. 82</p>
              </div>
            </div>

            <div className={styles.contacts}>
              <div className={styles.contact}>
                <img
                  src={CallIcon}
                  alt="Номер телефона"
                  className={styles.icon}
                />
                <a href="tel:78432070504" className={styles.text}>
                  +7 (843) 207-05-04
                </a>
              </div>

              <div className={styles.contact}>
                <img src={MailIcon} alt="Почта" className={styles.icon} />
                <a href="mailto:kazan@saby.pro" className={styles.text}>
                  kazan@saby.pro
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* EKB  */}
        <div
          className={styles.city}
          style={{ "--bg-image": `url(${EkbImage})` } as any}
        >
          <div className={styles.content}>
            <div className={styles.top}>
              <p className={styles.cityName}>Екатеринбург</p>

              <div className={styles.address}>
                <img src={MapIcon} alt="Адрес" className={styles.icon} />
                <p className={styles.text}>Ул. Мамина-Сибиряка, 40</p>
              </div>
            </div>

            <div className={styles.contacts}>
              <div className={styles.contact}>
                <img
                  src={CallIcon}
                  alt="Номер телефона"
                  className={styles.icon}
                />
                <a href="tel:73432264682" className={styles.text}>
                  +7 (343) 226-46-82
                </a>
              </div>

              <div className={styles.contact}>
                <img src={MailIcon} alt="Почта" className={styles.icon} />
                <a href="mailto:ekb@saby.pro" className={styles.text}>
                  ekb@saby.pro
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* SPB  */}
        <div
          className={styles.city}
          style={{ "--bg-image": `url(${SpbImage})` } as any}
        >
          <div className={styles.content}>
            <div className={styles.top}>
              <p className={styles.cityName}>Санкт-Петербург</p>

              <div className={styles.address}>
                <img src={MapIcon} alt="Адрес" className={styles.icon} />
                <p className={styles.text}>Ул. Заневский проспект 7/7</p>
              </div>
            </div>

            <div className={styles.contacts}>
              <div className={styles.contact}>
                <img
                  src={CallIcon}
                  alt="Номер телефона"
                  className={styles.icon}
                />
                <a href="tel:78122411246" className={styles.text}>
                  +7 (812) 241-1-246
                </a>
              </div>

              <div className={styles.contact}>
                <img src={MailIcon} alt="Почта" className={styles.icon} />
                <a href="mailto:spb@saby.pro" className={styles.text}>
                  spb@saby.pro
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cities;
